export class GetTableDataQualityHeaderResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "healthScore",
            "baseName": "healthScore",
            "type": "number",
            "format": ""
        },
        {
            "name": "activeIncidents",
            "baseName": "activeIncidents",
            "type": "number",
            "format": ""
        },
        {
            "name": "meta",
            "baseName": "meta",
            "type": "DataQualityTableMeta",
            "format": ""
        },
        {
            "name": "navStatus",
            "baseName": "navStatus",
            "type": "DataQualityNavStatus",
            "format": ""
        },
        {
            "name": "headlineKpis",
            "baseName": "headlineKpis",
            "type": "Array<DataQualityHeadlineKpi>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityHeaderResponse.attributeTypeMap;
    }
    constructor() {
    }
}
